<template>
    <Transition
        enter-active-class="transition duration-200 ease-out"
        enter-from-class="translate-y-4 opacity-0"
        enter-to-class="translate-y-0 opacity-100"
        leave-active-class="transition duration-150 ease-in"
        leave-from-class="translate-y-0 opacity-100"
        leave-to-class="translate-y-4 opacity-0"
    >
        <div v-if="visible" class="pointer-events-none fixed inset-x-0 bottom-5 z-40 px-2">
            <div class="relative">
                <button
                    v-if="showScrollTop"
                    :class="[
                        'pointer-events-auto absolute top-0 right-0 inline-flex size-9 transform-[translateY(calc(-100%-10px))]',
                        'cursor-pointer items-center justify-center rounded-full bg-highlight text-white',
                    ]"
                    @click="scrollToTop"
                >
                    <ArrowUp class="size-4" :stroke-width="2.4" />
                </button>

                <div class="lg:hidden">
                    <Button
                        type="button"
                        :label="buttonLabel"
                        :leading-icon="SlidersHorizontal"
                        no-tooltip
                        class="pointer-events-auto w-full rounded-md bg-highlight px-5 py-3 font-semibold text-white shadow-lg shadow-black/15"
                        @click="emit('open-filters')"
                    />
                </div>
            </div>
        </div>
    </Transition>
</template>

<script setup lang="ts">
import Button from '@/components/buttons/Button.vue';
import { categoryPageStore } from '@/stores/category/CategoryPageStore';
import { ArrowUp, SlidersHorizontal } from '@lucide/vue';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps<{
    visible: boolean;
    nbHits: number;
    showScrollTop: boolean;
}>();

const emit = defineEmits<{
    'open-filters': [];
}>();

const pageStore = categoryPageStore();
const { t } = useI18n();

const buttonLabel = computed((): string => {
    return pageStore.category?.settings?.mobile_filter_button_text ?? t('general.filter_amount_products', { count: props.nbHits });
});

const scrollToTop = (): void => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
};
</script>
